export const SITE = {
  name: 'Jay Johnson',
  email: 'jared@johnson.wtf',
  phone: '206 666 7511',
  phoneDot: '206·666·7511',
  linkedin: 'https://www.linkedin.com/in/thejaredjohnson',
  linkedinShort: 'in/thejaredjohnson',
  location: 'Seattle, WA',
  lastUpdated: 'apr 2026',
};

export const PM_DATA = {
  stencil: '◆ SR. TECHNICAL PRODUCT MANAGER · 15+ YRS',
  roleTapes: [
    { label: 'Product', color: 'pink' },
    { label: 'Platform', color: 'green' },
  ],
  lede: "messy business problems → elegant engineering. 0-to-1 innovation, scaling global social platforms, building products people actually use.",
  about: [
    "I specialize in technical product management and platform strategy. My career has taken me from optimizing massive social video communities (Paltalk, Camfrog) to architecting next-gen AI learning platforms (TechSmart). I don't just write tickets — I prototype, test my own APIs, and speak fluent \"engineer.\"",
    "Whether it's transforming legacy systems or navigating complex regulatory landscapes, I focus on driving retention, revenue, and clarity.",
  ],
  skills: [
    'Funnel Optimization', 'Process Improvement', 'Monetization',
    'HTML/CSS', 'Agile/Scrum', 'GenAI', 'Prototyping',
    'Growth', 'Marketplaces', 'AI Engineer',
  ],
  trail: [
    { yr: '2023-2025', role: 'Product Manager', co: 'TechSmart', note: 'Architecting next-gen AI learning platform.', meta: 'AI · ED-TECH' },
    { yr: '2021-2023', role: 'Product Manager', co: 'Byborg Enterprises', note: 'R&D, funnel optimization, marketplace growth.', meta: 'EXPERIMENTATION · MARKETPLACES' },
    { yr: '2010-2021', role: 'Product Manager', co: 'Paltalk', note: 'SDLC, Funnel, monetization, retention across global social video.', meta: 'SOCIAL · VIDEO' },
    { yr: '2008-2010', role: 'Founding CS, Trust & Safety', co: 'Camshare', note: 'Establish CS best practices, trust & safety protocols, fraud mitigation strategies', meta: 'SUPPORT · COMPLIANCE' },
  ],
  status: 'open to new opportunities — ready to dive in to help build outstanding products.',
};

export const THEATRE_DATA = {
  stencil: '◆ HEAD AUDIO ENGINEER · ARTSWEST · SEA',
  roleTapes: [
    { label: 'Sound', color: 'pink' },
    { label: 'Stagehand', color: 'green' },
  ],
  lede: "throwing faders, hanging lights, hitting things with a wrench. Making the sure the show is seen and heard, and the stage is safe.",
  about: [
    "Currently Head Audio Engineer at ArtsWest. Local musical theatre in Seattle — design, mix, run the show, strike, repeat. Standing by on headset, ch 2.",
    "If it makes noise, gets focused, hangs from a pipe, rolls on a deck, or needs a screwdriver — I'm your call.",
    "IATSE Local 15 Permit Worker, ask for me by name!", 
  ],
  skills: [
    'Sound Design', 'A1', 'A2', 'Audio Grip/Deckhand', 'RF Tech',  'Electrics: Hang', 'Electrics: Focus', 'Electrics: DMX', 'Board Op', 'Scenic Hand', 'Carpenter', 'Stagehand', 'Hitting things with a wrench',
  ],
  credits: [
    { yr: '2026', role: 'A1',                      show: 'Man of La Mancha', house: 'Reboot/Theatre Off Jackson' },
    { yr: '2025', role: 'A1',                      show: 'Penelope',         house: 'ArtsWest' },
    { yr: '2025', role: 'Sound Design · A1',       show: 'Anything Goes',    house: 'Reboot/Theatre Off Jackson' },
    { yr: '2025', role: 'A1',                      show: 'Here & Their',     house: 'JazzyRae/12th Ave Arts' },
    { yr: '2025', role: 'A1',                      show: 'Oliver',           house: 'Reboot/Theatre Off Jackson' },
  ],
  status: 'In the green room standing by for the next cue. Contact me to make the show go!',
};
